<template>
    <LayoutDashboard title="Permissões">
            <v-card outlined>
                <v-card-title>
                    <v-btn color="primary" @click="cadastrarPermissao" outlined>Cadastrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line hide-details>
                    </v-text-field>
                </v-card-title>
                <v-card-text>
                    <v-data-table :headers="headers" :items="getPermissoes" :search="search" dense>
                        <template v-slot:item.action="{ item }">
                            <v-btn color="primary" outlined small @click="visualizarPermissao(item)">Visualizar</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <ModalCadastroPermissao />
    </LayoutDashboard>
</template>

<script>
    import ModalCadastroPermissao from "@/pages/perfil/permissao/ModalCadastro"
    import { mapGetters, mapActions } from "vuex"

    export default {
        components: {
            ModalCadastroPermissao
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id', sortable: false },
                    { text: 'Grupo', align: 'left', sortable: false, value: 'grupo.nome'},
                    { text: 'Descrição', align: 'left', sortable: false, value: 'descricao'},
                    { text: 'Permissão', align: 'left', sortable: false, value: 'permissao'},
                    { text: 'Ações', value: 'action', sortable: false }
                ],
                funcionarios: [],
            }
        },
        computed: {
            ...mapGetters([
                'getPermissoes'
            ])
        },
        methods: {
            ...mapActions([
                'listarPermissao',
                'visualizarPermissao',
                'cadastrarPermissao',
            ])
        },
        created() {
            this.listarPermissao()
        }
    }
</script>